import styled, { css } from "styled-components";
import { Icon } from "../../../../../base/icons/icon/index.js";
import Tooltip from "../../../../../base/others/tooltip/index.js";
import { TooltipArrow, TooltipContent } from "../../../../../base/others/tooltip/styled.js";
import { FlexMixin, FontMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
import { Border, BorderRadius, Padding } from "../../../../../../styles/common/mixins/logical.styled.js";
import autocompleteThemes from "./themes/index.js";
export const TooltipDesktop = styled(Tooltip).withConfig({
    displayName: "styled__TooltipDesktop",
    componentId: "sc-20cfa234-0"
})`
	--tooltip-popper-bottom-padding: 6px;
	${TooltipContent} {
		${Padding({
    all: '0'
})};
		min-width: 575px;
		width: 100%;

		max-height: 400px;
		overflow-y: auto;
		text-align: left;

		&::-webkit-scrollbar {
			width: 6px;
		}
		&::-webkit-scrollbar-thumb {
			background: ${({ theme  })=>theme.colors.grays.base};
			${BorderRadius({
    all: '8px'
})}
		}
		&::-webkit-scrollbar-track {
			background: ${({ theme  })=>theme.colors.grays.light};
		}
	}

	${TooltipArrow} {
		display: none;
	}
`;
export const HeaderSuggestionDesktop = styled.div.withConfig({
    displayName: "styled__HeaderSuggestionDesktop",
    componentId: "sc-20cfa234-1"
})`
	${FlexMixin({
    align: 'center'
})}
	${FontMixin({
    weight: 'bold',
    size: 'medium'
})}
	${Padding({
    y: '8px',
    x: '0'
})};
	background-color: ${({ theme  })=>theme.colors.headerSuggestionSearcher?.background};
	${({ theme  })=>Border({
        all: `1px solid ${theme.colors.grays.light}`
    })};
	color: ${({ theme  })=>theme.colors.headerSuggestionSearcher?.base};
	text-transform: uppercase;

	${({ theme  })=>autocompleteThemes[theme.id]?.HeaderSuggestionDesktop?.()};
`;
export const IconWrapperDesktop = styled(Icon).withConfig({
    displayName: "styled__IconWrapperDesktop",
    componentId: "sc-20cfa234-2"
})`
	${FontMixin({
    size: 'large'
})}
	${Padding({
    y: '0',
    x: '12px'
})};
	color: ${({ theme  })=>theme.colors.grays.base};

	${({ theme  })=>autocompleteThemes[theme.id]?.IconWrapperDesktop?.()};
`;
export const LabelSuggestionDesktop = styled.div.withConfig({
    displayName: "styled__LabelSuggestionDesktop",
    componentId: "sc-20cfa234-3"
})`
	--background-color-selected: ${({ theme  })=>theme.colors.secondary.light};
	--text-color-selected: ${({ theme  })=>theme.colors.grays.dark};
	${FontMixin({
    size: 'medium',
    weight: 'light',
    height: 'medium'
})}
	overflow: hidden;
	${Padding({
    y: '12px',
    right: '20px',
    left: '44px'
})};
	text-overflow: ellipsis;
	white-space: nowrap;

	${({ $highlight  })=>$highlight && css`
			background-color: var(--background-color-selected);
			color: var(--text-color-selected);
		`};

	&:hover {
		background-color: ${({ theme  })=>theme.colors.secondary.light};
		color: ${({ theme  })=>theme.colors.grays.dark};
		cursor: pointer;
	}

	${({ theme  })=>autocompleteThemes[theme.id]?.LabelSuggestionDesktop?.()};
`;

//# sourceMappingURL=styled.js.map